import * as React from 'react';
import {
    FormDataConsumer,
    useTranslate,
} from 'react-admin';
import {config, localesConfig} from "../utils/config";

import {useForm} from "react-final-form";
import {Tooltip} from "@material-ui/core";

import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
//import FilledInput from '@mui/material/FilledInput';

import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
// import TextField from '@mui/material/TextField';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import get from 'lodash/get';


import {MyTranslateIcons} from "../icons/MyTranslateIcons";
import {styled} from "@mui/material/styles";
import {LinearProgress} from "@mui/material";
import {useEffect, useState} from "react";
import {MyAiIcons} from "../icons/MyAiIcons";
// import TranslateIcon from '@material-ui/Translate';
// import GTranslateIcon from '@material-ui/GTranslate';
import {getPrompt, getTranslate, getTransliteral} from "./CompForApi/utilsAPI";


import {Popover, Typography, Box, TextField} from '@mui/material';
// import InfoIcon from '@mui/icons-material/Info';
import KeyboardHideIcon from '@mui/icons-material/KeyboardHide';


export const StyledIconButton = styled(IconButton)(
    ({theme}) => ({
        marginTop: 22,
        '& .MuiSvgIcon-root': {
            //border: 0,
            color: '#2196f3', //'blue',//'gray',
        },
    })
);
export const StyledSelect = styled(Select)(
    ({theme}) => ({
        marginTop: 22,
        // '& .MuiOutlinedInput-notchedOutline': {
        '& fieldset': {
            border: 0,
        },
        '& .MuiSelect-select': {
            //border: 0,
            color: 'green',//'gray',
            width: 20,
            backgroundColor: 'unset',
        },
        '& .MuiSvgIcon-root': {
            //border: 0,
            color: 'green',//'gray',
        },
    })
);

export const MyTranslatableInputs = props => {
    return (
        <FormDataConsumer>
            {({formData, ...rest}) => {
                return (
                    <Block
                        {...props}
                        formData={formData}
                    />
                )
            }}
        </FormDataConsumer>
    )
}

const Block = props => {
    const {
        validate = false,
        formData,
        source,
        label,
        title = '',
        fullWidth = false,
        placeholder = false,
        isTranslate = true,
        slug = false,
        prompt = null
    } = props
    const translate = useTranslate();
    //const locale = useLocale();
    const formEdit = useForm();

    const [currentLocale, setCurrentLocale] = React.useState(localesConfig.defaultLocale);
    const [currentText, setCurrentText] = React.useState(null);
    const [progress, setProgress] = React.useState(false);
    const [flag, setFlag] = React.useState(1);
    const [startValid, setStartValid] = React.useState(false);
    const [openTooltip, setOpenTooltip] = useState(false);


    // console.log('formData======>', formData)
    // console.log(source, 'SOURCE=1==================>', currentText);
    // console.log(currentLocale, 'SOURCE=2==================>', currentLocale);

    // console.log(currentLocale, 'SOURCE=2==================>', currentText[currentLocale]);

    function testValid() {
        let res = startValid && validate && !currentText[localesConfig.defaultLocale] ? true : false
        return res
    }

    useEffect(() => {
        const handleClick = (event) => {
            const button = event.target.closest('button[type="submit"]');
            if (button) {
                setStartValid(true)
                // console.log("Клик по submit-кнопке:", button);
            }
        };

        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, []);

    useEffect(() => {
        let tmp
        //formEdit.change(source, null)
        if (formData.id) tmp = get(formData, source, {})
        else tmp = {}

        let newFormData = {}
        Object.entries(tmp).forEach((it) => {
            if (localesConfig.locales.indexOf(it[0]) < 0) {
                it[1] = ''
            }
            newFormData[it[0]] = it[1] || '' //undefined -- из-за єтого криво работало
        })

        localesConfig.locales.forEach(it => {
            if (tmp[it] === undefined) newFormData[it] = ''
        })

        //if (slug) formEdit.change(slug, tmp)
        formEdit.change(source, newFormData)
        setCurrentText(newFormData)

    }, []);// eslint-disable-line

    const handleClickTranslate = async () => {
        setProgress(true)
        let arrLocale = [currentLocale]
        if (currentLocale === localesConfig.defaultLocale) arrLocale = localesConfig.locales
        let res;
        // if (slug) res = await getTransliteral(formData[slug], arrLocale)
        if (slug) res = await getTransliteral(formData[slug], arrLocale)
        else res = await getTranslate(currentText[localesConfig.defaultLocale], arrLocale)
        setProgress(false)
        if (res) {
            let tmp = JSON.parse(JSON.stringify(currentText))
            localesConfig.locales.forEach(lang => {
                if (slug || lang !== localesConfig.defaultLocale) {
                    let it = get(res, `${lang}.name`, '')
                    // console.log('IT=======>', it);
                    if (it) {
                        tmp[lang] = it
                        //setCurrentText(tmp)
                        //formEdit.change(source, tmp)
                    }
                }
            })
            setCurrentText(tmp)
            formEdit.change(source, tmp)
        }
        formEdit.change('flagCountTranslate', flag + 1)
        setFlag(flag + 1)
    }

    const handleClickPrompt = async () => {
        let def = get(formData, source, null)
        setProgress(true)
        //JSON.stringify(formData)
        let res = await getPrompt(prompt, formData)
        setProgress(false)
        if (res) {
            localesConfig.locales.forEach(lang => {
                if (lang === localesConfig.defaultLocale) {
                    def[lang] = res
                } else {
                    def[lang] = '';
                }
            })
            setCurrentText(def)
            formEdit.change(source, def)
        }
        formEdit.change('flagCountTranslate', flag + 1)
        setFlag(flag + 1)
    }

    const handleChangeText = (event) => {
        // console.log('Text=============>', event.target.value)
        let tmp = JSON.parse(JSON.stringify(currentText))
        tmp[currentLocale] = event.target.value;
        setCurrentText(tmp)
        formEdit.change(source, tmp)
    }
    const handleChangeTextPopover = (event, locale) => {
        // console.log('Text=============>', event.target.value)
        let tmp = JSON.parse(JSON.stringify(currentText))
        tmp[locale] = event.target.value;
        setCurrentText(tmp)
        formEdit.change(source, tmp)
    }
    const handleChangeLocale = (event) => {
        //console.log('Locale=============>', event.target.value)
        setCurrentLocale(event.target.value)
    }


    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;


    const handleHover = () => {
        setOpenTooltip(true);
        setTimeout(() => setOpenTooltip(false), 3000); // скрыть через 2 секунды
    };
    // console.log(currentLocale, 'SOURCE===================>', currentText)
    if (currentText === null) return null
    return (
        <Tooltip
            open={openTooltip}
            // leaveDelay={1500}
            title={title}
            placement="top"
            arrow
        >
            <FormControl
                onMouseEnter={handleHover}
                // title={title}
                variant="outlined"
                // variant="filled"
                fullWidth={fullWidth}
                sx={{marginTop: 1, marginBottom: 3}}
            >
                <InputLabel
                    htmlFor="translate-button"
                    sx={{
                        color: testValid() && "red",
                        "&.Mui-focused": {color: testValid() && "red"}, // Делаем текст красным при фокусе
                    }}
                >
                    {translate(label)}
                </InputLabel>
                <OutlinedInput // FilledInput
                    error={testValid()}
                    size={"small"}
                    sx={{alignItems: 'start'}}
                    inputProps={{
                        style: {color: testValid() && "red"}, // Стили для текста placeholder
                    }}
                    placeholder={placeholder ? placeholder : translate(label)}
                    multiline
                    onChange={handleChangeText}
                    onClick={(event) => setStartValid(true)}
                    id="translate-button"
                    value={currentText[currentLocale]}
                    startAdornment={
                        <InputAdornment position="start" sx={{marginLeft: '-14px'}}>
                            <StyledSelect
                                labelId="translate-select-label"
                                id="translate-select"
                                value={currentLocale}
                                onChange={handleChangeLocale}
                                autoWidth
                                //label="Age"
                            >
                                {localesConfig.locales.map(it => {
                                    return (<MenuItem key={it} value={it}>{it}</MenuItem>)
                                })}
                            </StyledSelect>
                        </InputAdornment>
                    }
                    endAdornment={
                        <InputAdornment position="end">
                            <div>
                                <StyledIconButton
                                    aria-label="toggle password visibility2"
                                    onClick={handleClick}
                                    edge="end"
                                    style={{marginTop: slug && 16}}
                                >
                                    <KeyboardHideIcon/>
                                </StyledIconButton>
                                <Popover
                                    id={id}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                >
                                    <Box display="flex" flexDirection="column" gap={2} p={2} minWidth={450}>
                                        {localesConfig.locales.map((lang) => (
                                            <TextField
                                                multiline
                                                key={lang}
                                                label={lang.toUpperCase()}
                                                size="small"
                                                variant="outlined"
                                                value={currentText[lang]}
                                                onChange={(event) => handleChangeTextPopover(event, lang)}
                                                fullWidth
                                            />
                                        ))}
                                    </Box>
                                </Popover>
                                {prompt && currentLocale === localesConfig.defaultLocale
                                    ?
                                    <StyledIconButton
                                        aria-label="toggle password visibility2"
                                        onClick={handleClickPrompt}
                                        edge="end"
                                        style={{marginTop: slug && 16}}
                                    >
                                        <MyAiIcons/>
                                    </StyledIconButton>
                                    : null
                                }
                                {slug || (isTranslate && config.permission !== 'zenit')
                                    ?
                                    <StyledIconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickTranslate}
                                        edge="end"
                                        style={{marginTop: slug && 16}}
                                    >
                                        <MyTranslateIcons/>
                                        {slug &&
                                            <span
                                                style={{
                                                    color: 'red',
                                                    position: "absolute",
                                                    fontSize: 12,
                                                    top: 28,
                                                    left: 9
                                                }}
                                            >slug</span>
                                        }
                                    </StyledIconButton>
                                    : null
                                }
                            </div>
                        </InputAdornment>
                    }
                    label={label}
                />
                {progress && <LinearProgress color="secondary"/>}
                {testValid()
                    ?
                    <FormHelperText error id="username-error">
                        {translate('Required field')}{` (${localesConfig.defaultLocale})`}
                    </FormHelperText>
                    : null
                }
            </FormControl>
        </Tooltip>
    )
}